'use client';

import { motion } from 'framer-motion';
// import { World, GlobeConfig } from '../ui/globe';

/*
const globeConfig: GlobeConfig = {
  pointSize: 1,
  globeColor: '#1d072e',
  showAtmosphere: true,
  atmosphereColor: '#ffffff',
  atmosphereAltitude: 0.1,
  polygonColor: 'rgba(255,255,255,0.7)',
  emissive: '#000000',
  emissiveIntensity: 0.1,
  shininess: 0.9,
  ambientLight: '#ffffff',
  directionalLeftLight: '#ffffff',
  directionalTopLight: '#ffffff',
  pointLight: '#ffffff',
  arcTime: 2000,
  arcLength: 0.9,
  rings: 1,
  maxRings: 3,
  autoRotate: true,
  autoRotateSpeed: 2,
};

const data = [
  {
    order: 1,
    startLat: 64.2008,
    startLng: -149.4937,
    endLat: 34.0522,
    endLng: -118.2437,
    arcAlt: 0.1,
    color: '#0ea5e9',
  },
  {
    order: 2,
    startLat: 64.2008,
    startLng: -149.4937,
    endLat: -15.7975,
    endLng: -47.8919,
    arcAlt: 0.2,
    color: '#06b6d4',
  },
  {
    order: 3,
    startLat: -15.7975,
    startLng: -47.8919,
    endLat: 38.7223,
    endLng: -9.1393,
    arcAlt: 0.15,
    color: '#00d9ff',
  },
  {
    order: 4,
    startLat: 51.5074,
    startLng: -0.1278,
    endLat: 28.6139,
    endLng: 77.209,
    arcAlt: 0.25,
    color: '#0ea5e9',
  },
  {
    order: 5,
    startLat: 28.6139,
    startLng: 77.209,
    endLat: 43.1332,
    endLng: 131.9113,
    arcAlt: 0.2,
    color: '#06b6d4',
  },
  {
    order: 6,
    startLat: 28.6139,
    startLng: 77.209,
    endLat: -1.2921,
    endLng: 36.8219,
    arcAlt: 0.18,
    color: '#00d9ff',
  },
];
*/

export function GlobeSection() {
  return (
    <div className="py-40 w-full bg-white dark:bg-black">
      <div className="mx-auto max-w-7xl text-center px-4">
        <p className="font-bold text-xl md:text-4xl dark:text-white text-black">
          Remote{' '}
          <span className="text-neutral-400">
            {'Connectivity'.split('').map((word, idx) => (
              <motion.span
                key={idx}
                className="inline-block"
                initial={{ x: -10, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: idx * 0.04 }}
              >
                {word}
              </motion.span>
            ))}
          </span>
        </p>
        <p className="text-sm md:text-lg text-neutral-500 max-w-2xl mx-auto py-4">
          Break free from traditional boundaries. Work from anywhere, at the comfort of your own studio apartment.
          Perfect for Nomads and Travellers.
        </p>
      </div>
      <div className="max-w-5xl mx-auto px-4 mt-12 h-96">
        {/* <World globeConfig={globeConfig} data={data} /> */}
        <div className="flex items-center justify-center h-full text-white">
          Globe Component Temporarily Disabled
        </div>
      </div>
    </div>
  );
}
